document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Mobile Gallery Scroll Snap logic
  const scrollContainer = document.getElementById('ProductGalleryScroll');
  const dots = document.querySelectorAll('.gallery-dot');
  
  if (scrollContainer && dots.length > 0) {
    scrollContainer.addEventListener('scroll', () => {
      const scrollLeft = scrollContainer.scrollLeft;
      const width = scrollContainer.offsetWidth;
      const index = Math.round(scrollLeft / width);
      
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    });
  }

  // 2. Accordions
  const accordions = document.querySelectorAll('.accordion-item');
  accordions.forEach(acc => {
    const header = acc.querySelector('.accordion-header');
    const content = acc.querySelector('.accordion-content');
    
    // Initialize open ones
    if (acc.classList.contains('is-open')) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
    
    header.addEventListener('click', () => {
      const isOpen = acc.classList.contains('is-open');
      
      // Close all others
      accordions.forEach(a => {
        a.classList.remove('is-open');
        a.querySelector('.accordion-content').style.maxHeight = null;
      });
      
      if (!isOpen) {
        acc.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

  // 3. Variant Selection Logic
  const variantRadios = document.querySelectorAll('.variant-radio');
  const variantsDataEl = document.getElementById('ProductVariantsData');
  
  if (variantRadios.length > 0 && variantsDataEl) {
    const variantsData = JSON.parse(variantsDataEl.textContent);
    const productSelect = document.getElementById('ProductSelect');
    const priceDisplay = document.getElementById('ProductPrice');
    const stickyPriceDisplay = document.getElementById('MobileStickyPrice');
    const addToCartBtn = document.getElementById('AddToCart');
    const addToCartText = document.getElementById('AddToCartText');
    const form = document.querySelector('.product-form');
    
    // Group radios by option name
    const updateVariant = () => {
      // Find selected options
      const selectedOptions = Array.from(document.querySelectorAll('.variant-radio:checked')).map(r => r.value);
      
      // Find matching variant
      const matchedVariant = variantsData.find(v => {
        return v.options.every((val, index) => val === selectedOptions[index]);
      });
      
      if (matchedVariant) {
        // Update hidden input
        productSelect.value = matchedVariant.id;
        
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url);
        
        // Update Price
        const priceFormatted = Shopify.formatMoney(matchedVariant.price);
        priceDisplay.innerHTML = priceFormatted;
        if(stickyPriceDisplay) stickyPriceDisplay.innerHTML = priceFormatted;
        
        // Update Button
        if (matchedVariant.available) {
          addToCartBtn.disabled = false;
          addToCartText.innerHTML = `Add to cart — ${priceFormatted}`;
        } else {
          addToCartBtn.disabled = true;
          addToCartText.innerHTML = 'Sold Out';
        }
      } else {
        addToCartBtn.disabled = true;
        addToCartText.innerHTML = 'Unavailable';
      }
    };
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', updateVariant);
    });
  }

  // 4. Mobile Sticky Cart Logic
  const stickyCart = document.getElementById('MobileStickyCart');
  const addToCartBtn = document.getElementById('AddToCart');
  
  if (stickyCart && addToCartBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // If the main add to cart button is NOT visible, show sticky cart
        if (!entry.isIntersecting && window.innerWidth <= 900) {
          stickyCart.classList.add('is-visible');
        } else {
          stickyCart.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    
    observer.observe(addToCartBtn);
  }

});
